/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbResourceCategory {
    getFixupPrototypeFunction() { return ServiceNowCmdbResourceCategory.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbResourceCategory>): ServiceNowCmdbResourceCategory {
        let obj = Object.assign(new ServiceNowCmdbResourceCategory(), model);
        ServiceNowCmdbResourceCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbResourceCategory>): ServiceNowCmdbResourceCategory {
        if (!model) return null;
        return ServiceNowCmdbResourceCategory.newInstance(<ServiceNowCmdbResourceCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbResourceCategory) {
        if (!obj) return;

        models.ServiceNowCmdbResourceCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbResourceCategory): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbResourceCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_types) {
            for (let val of this.resource_types) {
                models.ServiceNowCmdbResourceType.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the Resource Category
     */
    resource_category: string;

    /**
     * List of Resource Type
     */
    resource_types: Array<models.ServiceNowCmdbResourceType>;

}
